const BASE_INPUT_HEIGHT = 32;
const MAX_ATTACHMENTS = 6;
const MAX_SIZE_MB = 5 * 1000 * 1000;
const MAX_ROWS = 4;
const INPUT_PADDING = 20;

export { BASE_INPUT_HEIGHT as B, INPUT_PADDING as I, MAX_ATTACHMENTS as M, MAX_SIZE_MB as a, MAX_ROWS as b };
//# sourceMappingURL=constants-DOKLuynE.js.map
